import MediaUpdateGenerator from "./MediaUpdateGenerator";

export default MediaUpdateGenerator;
